const sizes = {
  constrains: {
    desktop: 1300,
    filtersModal: 1350,
    filtersModalContent: 950,
  },
  media: {
    xxSmallMaxWidth: 360,
    xSmallMaxWidth: 400,
    smallMaxWidth: 640,
    mediumMinWidth: 1024,
    mediumMaxWidth: 1180,
    tabletMinWidth: 768,
    xTabletMinWidth: 780,
    tabletMaxWidth: 800,
    tabletPortrait: 900,
    tabletLandscape: 1080,
    modalWidth: 580,
  },
  gutter: {
    small: 20,
    large: 70,
  },
  img: { small: '$440x248$', medium: '$800x450$', large: '$1040x520$' },
};

export default sizes;
